export enum InjectedScriptAction {
  CreateUINotification = 'createUINotification',
  ExtensionSignedInStatusRetrieved = 'extensionSignedInStatusRetrieved',
  GetExtensionSignedInStatus = 'getExtensionSignedInStatus',
  GetThirdPartyAppCredentials = 'getThirdPartyAppCredentials',
  GetThirdPartyAppCredentialsPopupDetails = 'getThirdPartyAppCredentialsPopupDetails',
  InitiateThirdPartyAppLogin = 'initiateThirdPartyAppLogin',
  OpenThirdPartyAppCredentialsPopup = 'openThirdPartyAppCredentialsPopup',
  SetFeedback = 'setFeedback',
  ThirdPartyAppCredentialsPopupDetailsRetrieved = 'thirdPartyAppCredentialsPopupDetailsRetrieved',
  ThirdPartyAppCredentialsRetrieved = 'thirdPartyAppCredentialsRetrieved',
}
